import { useEffect } from "react";
import useAuth from "./useAuth"
import useAxiosPrivate from "./useAxiosPrivate";

const useLocalStorage = () => {
    const { ready } = useAuth();
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        if (!ready) return;
        getSystemSettings();
    }, [ready]);
    
    const getSystemSettings = async () => {
        try {
            const res = await axiosPrivate.get('/settings');
            if (res.status === 200) {
                const systemSettings = res.data.data;
                const organization = systemSettings.organization;
                const system = systemSettings.system;
                const eComSynch = systemSettings.eComSynch;
                localStorage.setItem('organization', JSON.stringify(organization));
                localStorage.setItem('system', JSON.stringify(system));
                localStorage.setItem('eComSynch', JSON.stringify(eComSynch));
            }
        } catch (error) { console.error("Error fetching system settings:", error) }
    };

    return getSystemSettings;
}

export default useLocalStorage;